(() => {
  if (customElements.get('sissilux-featured-review')) return;
  class FeaturedReview extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.querySelector('.sfr__link')?.addEventListener('click', event => {
        const id = event.currentTarget.hash.slice(1);
        const target = document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'start'});
        history.replaceState(null, '', '#' + id);
        const heading = target.querySelector('h2');
        if (heading) {
          const hadTabindex = heading.hasAttribute('tabindex');
          if (!hadTabindex) heading.setAttribute('tabindex', '-1');
          heading.focus({preventScroll:true});
          if (!hadTabindex) heading.addEventListener('blur', () => heading.removeAttribute('tabindex'), {once:true});
        }
      }, {signal:this.events.signal});
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; }
  }
  customElements.define('sissilux-featured-review', FeaturedReview);
})();
